export function toSeconds(timecode,framerate){
  if(!framerate) var framerate = 24;
  let t = timecode.split(':');
  let h = t[0] * 1;
  let m = t[1] * 1;
  let s = t[2] * 1;
  let f = t[3] * 1;
  let seconds = h * 60 * 60 + m * 60 + s + f / 24;
  return Math.round(seconds*10)/10;
}

export function toSmtp(seconds,framerate) {
  if(!framerate) var framerate = 24;
  var f = Math.floor((seconds % 1) * framerate);
  var s = Math.floor(seconds);
  var m = Math.floor(s / 60);
  var h = Math.floor(m / 60);
  m = m % 60;
  s = s % 60;
  if (h < 10) h = "0" + h;
  if (m < 10) m = "0" + m;
  if (s < 10) s = "0" + s;
  if (f < 10) f = "0" + f;
  var timecode = h + ":" + m + ":" + s + ":" + f;
  return timecode;
}



// WEBPACK FOOTER //
// ./src/client/lib/timecode.js